import { render, staticRenderFns } from "./admin.smartwatch.new.page.vue?vue&type=template&id=732cf4a4&scoped=true&"
import script from "./admin.smartwatch.new.page.vue?vue&type=script&lang=js&"
export * from "./admin.smartwatch.new.page.vue?vue&type=script&lang=js&"
import style0 from "./admin.smartwatch.new.page.vue?vue&type=style&index=0&id=732cf4a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732cf4a4",
  null
  
)

export default component.exports